"use client";

import { Navbar, Dropdown, Avatar, Badge } from "flowbite-react";
import { Link, useNavigate } from "react-router-dom";
import { MdDashboard } from "react-icons/md";
import { Button } from "antd";





const Header = () => {
  const navigate = useNavigate();

  const gotoEmployees = () => navigate('/employee-app/employees/');
  const gotoDepartment = () => navigate('/employee-app/departments/');
  return (
    <Navbar fluid rounded className="mb-3 border-b-2">
      <div className="flex">
        <Link className="me-3 p-2 border-2 rounded hover:text-blue-500" to={'/'}>{<MdDashboard />}</Link>
        <Navbar.Brand as={Link} to={'/employee-app/'} className="w-50">
          <span className="self-center whitespace-nowrap text-xl font-semibold dark:text-white">Employees</span>
        </Navbar.Brand>
      </div>
      <div className="flex">
        <Button type="text" onClick={gotoEmployees}>
          <span className="mx-2 font-normal text-lightgray-500">Employees</span>
        </Button>
        <Button type="text" onClick={gotoDepartment}>
          <span className="mx-2 font-normal text-lightgray-500" style={{fontSize: '15px',}}>Departements</span>
        </Button>
        
        <Dropdown arrowIcon={false} inline label={<span className="mx-2">Configurations</span>}>
          <Dropdown.Item>Settings</Dropdown.Item>
          <Dropdown.Item as={Link} to={'/employee-app/job-positions'}>Job Positions</Dropdown.Item>
          <Dropdown.Item >Plans</Dropdown.Item>
          
        </Dropdown>
      </div>
      <div className="">
        
        <Dropdown
          arrowIcon={false}
          inline
          label={
            <Avatar alt="User settings" img="https://flowbite.com/docs/images/people/profile-picture-5.jpg" rounded />
          }
        >
          <Dropdown.Header>
            <span className="block text-sm">Bonnie Green</span>
            <span className="block truncate text-sm font-medium">name@flowbite.com</span>
          </Dropdown.Header>
          <Dropdown.Item>Dashboard</Dropdown.Item>
          <Dropdown.Item>Settings</Dropdown.Item>
          <Dropdown.Item>Earnings</Dropdown.Item>
          <Dropdown.Divider />
          <Dropdown.Item>Sign out</Dropdown.Item>
        </Dropdown>
        {/* <Navbar.Toggle /> */}
      </div>
      {/* <Navbar.Collapse>
        <Navbar.Link href="#" active>
          Home
        </Navbar.Link>
        <Navbar.Link href="#">About</Navbar.Link>
        <Navbar.Link href="#">Services</Navbar.Link>
        <Navbar.Link href="#">Pricing</Navbar.Link>
        <Navbar.Link href="#">Contact</Navbar.Link>
      </Navbar.Collapse> */}
    </Navbar>
  );
}




export default Header;